// @ts-check
import { gql } from '@apollo/client/core';
import React from 'react';
import useProduct from './useProduct';
import { Flex, Image } from '../';
import BottleImagePlaceholder from './BottleImagePlaceholder';

/**
 *
 * @param {{
 *  product?: object;
 *  height?: number;
 *  width?: number;
 *  style?: import('@react-pdf/renderer').default.Styles
 *  debug?: boolean;
 * }} props
 * @returns
 */
export default function BottleImage({
  product: data,
  height,
  width,
  style,
  debug,
}) {
  const product = useProduct(data);
  if (!hasContent(product))
    return (
      <Flex style={{ justifyContent: 'center' }}>
        <BottleImagePlaceholder height={height} width={width} />
      </Flex>
    );
  return (
    <Image
      src={product?.bottleImage?.fixed?.src}
      height={height}
      width={width}
      style={style}
      trim
      debug={debug}
    />
  );
}

BottleImage.hasContent = hasContent;

function hasContent({ bottleImage }) {
  return !!bottleImage?.fixed?.src;
}

BottleImage.fragment = gql`
  fragment BottleImage on Product {
    bottleImage {
      # This doesn't matter because the URL is recalculated by Image component
      # This should replaced with sourceUrl when it returns a String
      fixed(height: 1, width: 1, crop: PAD) {
        src
      }
    }
  }
`;
